module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }